import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const HomeRedirect = () => {
  const { token, user, authStatus } = useAuth();
  if (authStatus === "checking" && token) return <Navigate to="/dashboard" replace />;
  return token && user ? (
    <Navigate to="/dashboard" replace />
  ) : (
    <Navigate to="/home" replace />
  );
};

export default HomeRedirect;
